import moment from 'moment';
export default function mapBulkUpdateUsersToLookup(updatedUserObj, lookup, allUsers) {
    if (!lookup || !allUsers || !updatedUserObj) {
        throw Error("Need look and userData");
    }
    let changedUser = updatedUserObj.useriddetail.split(',');
    let {
        firmBranches,
        department,
        rightsGroupNames,
        pageDetails,
        titleLevelList,
        industry,
        nicheGroups,
        expertise,
        rolesDetails
    } = lookup;
    // console.log("updatedUserObj", updatedUserObj);
    allUsers = allUsers.map((user) => {
        // if (!changedUser.includes((user.user_id).toString())) {
        //     return user;
        // }
        if (changedUser.includes((user.user_id).toString())) {
            //branch name
            let userBranch = firmBranches.find(
                loc => updatedUserObj.branch_id === loc.branch_id
            );
            if (userBranch) {
                user.branch_id = userBranch.branch_id;
                user.branch_name = userBranch.branch_name;
            }

            //departments

            // console.log("updatedUserObj.department", updatedUserObj.department)
            if (updatedUserObj.department) {
                let userDepartmentsList = updatedUserObj.department.split(",");
                let userDepartments = department.filter((dep) => userDepartmentsList.includes(dep.department_id.toString()));

                //  console.log("userDepartmentsList", userDepartmentsList, userDepartments)
                if (userDepartments && userDepartments.length) {
                    user.department_names = userDepartments.map(d => d.department_name).join("|");
                    user.department = userDepartments.map(d => d.department_id).join(",");
                }

            }
            //  console.log(" before checking user departments", user.department, "names", user.department_names);
            if (updatedUserObj && updatedUserObj.department == 0 && updatedUserObj.department.length) {
                user.department_names = "";
                user.department = 0;

            }
            // console.log("after checking user departments", user.department, "names", user.department_names);
            //Task Locations
            // console.log("updatedUserObj.task_Locations", updatedUserObj.task_Locations)
            if (updatedUserObj.task_Locations) {
                let taskLocationsList = updatedUserObj.task_Locations.split(",");
                let taskLocations = firmBranches.filter((loc) => taskLocationsList.includes(loc.branch_id.toString()));
                //    console.log("taskLocationsList", taskLocationsList, taskLocations)

                if (taskLocations && taskLocations.length) {
                    user.task_location_names = taskLocations.map(tl => tl.branch_name).join("|");
                    user.task_Locations = taskLocations.map(tl => tl.branch_id).join(",");
                }
            }

            if (updatedUserObj && updatedUserObj.task_Locations == 0 && updatedUserObj.task_Locations.length) {
                user.task_location_names = "";
                user.task_Locations = 0;
            }
            // userRightGroupNames
            //  console.log("updatedUserObj.belongsto_group", updatedUserObj.belongsto_group)
            if (updatedUserObj.belongsto_group) {
                let rightsGroupNamesList = updatedUserObj.belongsto_group.split(",");
                let userRightGroupNames = rightsGroupNames.filter((group) => rightsGroupNamesList.includes(group.Group_id.toString()));
                // console.log("rightsGroupNamesList", rightsGroupNamesList, userRightGroupNames)

                if (userRightGroupNames && userRightGroupNames.length) {
                    user.belongsto_group_names = userRightGroupNames.map(el => el.Group_name).join("|");
                    user.belongsto_group = userRightGroupNames.map(el => el.Group_id).join(",");
                }
            }

            if (updatedUserObj && updatedUserObj.belongsto_group == 0 && updatedUserObj.belongsto_group.length) {
                user.belongsto_group_names = "";
                user.belongsto_group = 0;
            }

            // Pinned views for MyView
            if (updatedUserObj.page_id) {
                let pinnedViewsForMyviewList = updatedUserObj.page_id.split(",");
                let pinnedViewsForMyview = [];
                pinnedViewsForMyviewList.map(_pinnstr => {
                    return pageDetails.filter(pv => {
                        if (pv.Bid.toString() === _pinnstr) pinnedViewsForMyview.push(pv);
                    });
                })

                // let pinnedViewsForMyview = pageDetails.filter((pv) => pinnedViewsForMyviewList.includes(pv.Bid.toString()));
                //  console.log("pinnedViewsForMyviewList", pinnedViewsForMyviewList, pinnedViewsForMyview)

                if (pinnedViewsForMyview && pinnedViewsForMyview.length) {
                    user.pinned_views_for_myview = pinnedViewsForMyview.map(e => e.Bucketname).join("|");
                    user.page_id = pinnedViewsForMyview.map(e => e.Bid).join(",");

                }



            }

            if (updatedUserObj && updatedUserObj.page_id == 0 && updatedUserObj.page_id.length) {
                user.pinned_views_for_myview = "";
                user.page_id = 0;
            }
            //Default Myview view
            if (updatedUserObj.landingPageId) {
                let defaultMyView = pageDetails.find(
                    myView => updatedUserObj.landingPageId === myView.Bid
                );

                console.log("defaultMyView", defaultMyView)
                if (defaultMyView) {
                    // let myViewId = defaultMyView.Bid;
                    // let pinnedViewsIds = user.page_id.split(",");
                    let myView = defaultMyView.Bucketname;
                    let pinnedViews = user.pinned_views_for_myview.split("|");

                    if (pinnedViews[0] != myView) {
                        let myviewIndex = pinnedViews.indexOf(myView);
                        if (myviewIndex != -1) {
                            pinnedViews.splice(myviewIndex, 1);
                        }
                        pinnedViews.unshift(myView);
                    }
                    user.pinned_views_for_myview = pinnedViews.join("|");
                    user.default_myview_name = defaultMyView.Bucketname;
                    user.landingPageId = defaultMyView.Bid;
                } else {
                    user.default_myview_name = "";
                    user.landingPageId = 0;


                }
            }

            if (updatedUserObj && updatedUserObj.landingPageId === 0) {
                user.default_myview_name = "";
                user.landingPageId = 0;
            }
            //title level
            //  console.log("updatedUserObj.title_level", updatedUserObj.title_level)
            if (updatedUserObj.title_level) {
                let titleLevel = titleLevelList.find(
                    title => updatedUserObj.title_level === title.titleORlevel_id
                );
                //  console.log("titleLevel", titleLevel)
                if (titleLevel) {
                    user.title_or_level_names = titleLevel.titleORlevel_name;
                    user.title_level = titleLevel.titleORlevel_id
                }
            }

            if (updatedUserObj && updatedUserObj.title_level === 0) {
                user.title_or_level_names = "";
                user.title_level = 0;
            }
            //Industry Group
            // console.log("updatedUserObj.industry_group", updatedUserObj.industry_group)
            if (updatedUserObj.industry_group) {
                let industryList = updatedUserObj.industry_group.split(",");
                let userIndustries = industry.filter((ind) => industryList.includes(ind.industry_id.toString()));

                //    console.log("industryList", industryList, userIndustries)
                if (userIndustries && userIndustries.length) {
                    user.industry_names = userIndustries.map(el => el.industry_name).join("|");
                    user.industry_group = userIndustries.map(el => el.industry_id).join(",");
                }
            }

            if (updatedUserObj && updatedUserObj.industry_group == 0 && updatedUserObj.industry_group.length) {
                user.industry_names = "";
                user.industry_group = 0;
            }
            //niche_group
            // console.log("updatedUserObj.niche_group", updatedUserObj.niche_group)
            if (updatedUserObj.niche_group) {
                let nicheGroupList = updatedUserObj.niche_group.split(",");
                let userNicheGroups = nicheGroups.filter((niche) => nicheGroupList.includes(niche.nicheORgroup_id.toString()));
                //console.log("nicheGroupList", nicheGroupList, userNicheGroups)

                if (userNicheGroups && userNicheGroups.length) {
                    user.niche_or_group_names = userNicheGroups.map(el => el.nicheORgroup_name).join("|");
                    user.niche_group = userNicheGroups.map(el => el.nicheORgroup_id).join(",");
                }
            }

            if (updatedUserObj && updatedUserObj.niche_group == 0 && updatedUserObj.niche_group.length) {

                user.niche_or_group_names = " ";
                user.niche_group = 0;
            }
            // expertise
            // console.log("updatedUserObj.expertise", updatedUserObj.expertise)
            if (updatedUserObj.expertise) {
                let expertiseList = updatedUserObj.expertise.split(",");
                let userExpertise = expertise.filter((exp) => expertiseList.includes(exp.expertise_id.toString()));
                //console.log("expertiseList", expertiseList, userExpertise)

                if (userExpertise && userExpertise.length) {
                    user.expertise_names = userExpertise.map(el => el.expertise_name).join("|");
                    user.expertise = userExpertise.map(el => el.expertise_id).join(",");
                }
            }

            if (updatedUserObj && updatedUserObj.expertise == 0 && updatedUserObj.expertise.length) {
                user.expertise_names = "";
                user.expertise = 0;
            }
            //primary role
            // console.log("updatedUserObj.primary_role", updatedUserObj.primary_role);
            if (updatedUserObj.primary_role) {
                let primaryRole = rolesDetails.find(
                    role => updatedUserObj.primary_role === role.role_id
                );

                //console.log("primaryRole", primaryRole, user);
                if (primaryRole) {
                    user.primary_role_name = primaryRole.role_name;
                    user.primary_role = primaryRole.role_id;
                }
            }

            if (updatedUserObj && updatedUserObj.primary_role === 0) {
                user.primary_role_name = "";
                user.primary_role = 0;
            }
            //secondary role
            //  console.log("updatedUserObj.secondary_role", updatedUserObj.secondary_role);
            if (updatedUserObj.secondary_role) {
                let secondaryRole = rolesDetails.find(
                    role => updatedUserObj.secondary_role === role.role_id
                );

                // console.log("secondaryRole", secondaryRole);
                if (secondaryRole) {
                    user.secondary_role_name = secondaryRole.role_name;
                    user.secondary_role = secondaryRole.role_id;
                }
            }

            if (updatedUserObj && updatedUserObj.secondary_role === 0) {

                user.secondary_role_name = "";
                user.secondary_role = 0;
            }

            //Residence City
            // if (updatedUserObj.ResidenceCity) {
            //     user.residenceCity = updatedUserObj.ResidenceCity;
            // }
            // Ip Address Range
            if (updatedUserObj.ip_from) {
                user.ip_from = updatedUserObj.ip_from;
            }
            user.selected = false;
        }

        return user;
    });

    return allUsers;
}


